import { useDocumentWithTokenQuery } from 'generated/graphql';
import { useParams } from 'react-router-dom';
import { useToken } from '../../lib';
import Esignature from './Esignature';
import Upload from './Upload';

function Document() {
  const token = useToken();
  const { documentId: id } = useParams() as { documentId: string };

  const { loading, data } = useDocumentWithTokenQuery({ variables: { id, token } });

  if (loading || !data) return null;

  if (data.documentWithToken.esignLink) return <Esignature document={data.documentWithToken} />;

  return <Upload document={data.documentWithToken} />;
}

export default Document;
